import React from 'react';
import { StyledButtonRightIcon, StyledButtonDefaultIcon } from './Button.styles.es.js';

/* eslint-disable filenames/match-regex */
function renderIcon(icon, _ref) {
  var align = _ref.align,
      animateIconRight = _ref.animateIconRight;
  var StyledButtonIcon = animateIconRight ? StyledButtonRightIcon : StyledButtonDefaultIcon;
  return /*#__PURE__*/React.createElement(StyledButtonIcon, {
    align: align
  }, icon);
}

export { renderIcon };
